export default "__VITE_ASSET__329db112__"